<template>
  <div>
    <v-row>
      <v-col
        >Show this category if {{ parentNodeName }}
        <v-select
          :items="items"
          :value="items[0]"
          filled
          dense
          v-model="conditionType"
        ></v-select>
      </v-col>
      <v-col>
        <div v-for="(choice, index) of parentRecord.meta.choices" :key="index">
          <v-checkbox
            v-model="conditionHolder"
            @change="setConditions"
            :value="choice"
            :label="choice"
            column
            dense
          ></v-checkbox>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    node: Object,
    parentNodeId: String,
    parentNodeName: String,
    selectedRecord: Object,
    parentRecord: Object,
    index: Number,
    prexistingCondition: String
  },
  created() {
    if (this.node.meta.evaltype === "contains")
      this.conditionType = "contains the following";
    if (this.prexistingCondition != this.index) {
      this.conditionHolder = [this.prexistingCondition.trim()];
      this.setConditions(this.conditionHolder);
    }
  },
  data() {
    return {
      conditionHolder: [],
      items: ["is equal to", "contains the following"],
      conditionType: "is equal to"
    };
  },
  computed: {
    conditionevaltype: function() {
      if (this.conditionType === "is equal to") return "equal";
      return "contains";
    }
  },
  watch: {
    conditionType: function() {
      this.setConditions(this.conditionHolder);
    }
  },
  methods: {
    setConditions(condition) {
      let modifiedCondition = this.convertFromArrayToString(condition);
      let conditionObject = {
        condition: modifiedCondition,
        index: this.index,
        conditionevaltype: this.conditionevaltype
      };

      this.$emit("setCondition", conditionObject);
    },
    convertFromArrayToString(array) {
      let conditionString = "";

      for (let item of array) {
        conditionString = conditionString.concat(item);
        if (array.indexOf(item) !== array.length - 1) {
          conditionString += " /,/ ";
        }
        if (array.indexOf(item) === array.length - 1) {
          break;
        } else {
          conditionString.concat(" == ");
        }
      }

      return conditionString;
    }
  }
};
</script>

<style></style>
